<ng-content
  select="
  [palantir-layout-header], palantir-layout-header,
  [palantir-card-header], palantir-card-header
"
/>

<ng-content select="[palantir-layout-content], palantir-layout-content" />
<ng-content />

<ng-content
  select="
  [palantir-layout-footer], palantir-layout-footer,
  [palantir-card-footer], palantir-card-footer,
  [palantir-dialog-actions], palantir-dialog-actions
"
/>
